import { observable, action, makeObservable } from 'mobx';
import { intersection } from 'lodash';
import type { IUsersPermissionsModel } from 'interfaces/user/IUserPermissionsModel';

class ApplicationUserRightsStore {
  constructor() {
    makeObservable(this);
  }

  @observable permissions: string[] = [];

  public IsAllowed(requiredPermissions: string[]): boolean {
    const intsec = intersection(this.permissions, requiredPermissions);
    if (intsec.length === requiredPermissions.length) {
      return true;
    }
    return false;
  }

  @action setData(data: IUsersPermissionsModel): void {
    this.permissions = data.permissions;
  }
}

export const ApplicationUserRights = new ApplicationUserRightsStore();
